module.exports = "<div class=\"live-info\"><%= live %></div>\n<button type=\"button\" class=\"live-button\"><%= backToLive %></button>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/dvr_controls/public/index.html
 ** module id = 140
 ** module chunks = 0
 **/